import angular from 'angular';
import { dynamicSortMultiple } from '@/shared/utils/dynamicSort';
import adminpulse from '@/shared/utils/adminpulse';
import SignalRService from '@/shared/services/SignalRService';

angular
  .module('cxRegistrations')
  .controller('PriceListCtrl', [
    '$rootScope',
    '$scope',
    'dataCache',
    'resourceFactorySvc',
    'registrationService',
    'flySvc',
    '$filter',
    'dialogsSvc',
    'regDialogsSvc',
    '$http',
    'appUrls',
    '$translate',
    'FileSaver',
    'checkSecurity',
    'checkFeature',
    priceListCtrl,
  ]);

function priceListCtrl(
  $rootScope,
  $scope,
  dataCache,
  resourceFactorySvc,
  registrationService,
  flySvc,
  $filter,
  dialogsSvc,
  regDialogsSvc,
  $http,
  appUrls,
  $translate,
  FileSaver,
  checkSecurity,
  checkFeature,
) {
  var vm = this;
  var regResource = resourceFactorySvc.get('resource');
  vm.registrationService = registrationService;
  vm.showHistory = false;
  vm.creatingReport = false;

  var showError = function(error) {
    flySvc.error(error.data.code, error.data.parameters);
    return '';
  };
  vm.hasPermission = (resourceType, privilege) => {
    let functionality;
    if ([0, 1, 2].includes(resourceType)) {
      functionality = 'Pricelist';
    } else if ([3, 4].includes(resourceType)) {
      functionality = 'AbsenceAndCounters';
    } else if (resourceType === 5) {
      functionality = 'TrainingManagement';
    } else {
      return false;
    }
    return checkSecurity(functionality + ':' + privilege);
  };

  vm.openTranslateDialog = function(item, type) {
    if (!item || item.isRemoved) return;
    dialogsSvc
      .translateListItem(type, item.id, item.name, { maxlength: 255 })
      .then(function(result) {
        if (result) {
          if (result.defaultValue) {
            if (type === 'resource') vm.saveResource(item, 'name', result.defaultValue);
            if (type === 'resourcecategory') vm.saveCategory(item, 'name', result.defaultValue);
          }
          if (
            type === 'resourcecategory' &&
            result.changes &&
            result.changes.length &&
            item.resource
          ) {
            var key = `resource_${item.resource.id}`;
            var changes = result.changes.map(x => ({ ...x, key: key }));
            $http.put(appUrls.api + '/api/translation/lists/0', changes);
          }

          // No need to update the translations in the resource.
          // The reload of the translations triggers the $translateChangeSuccess event
        }
      });
  };

  //#region Retrieve
  vm.retrieveResources = function(params) {
    console.trace(params);
    params.includeRemoved = !!vm.showHistory;
    params.type = -1; // show all resources
    console.log(params);
    return $http.get(`${appUrls.api}/api/resource/list`, { params }).then(function({ data }) {
      if (!checkFeature('Training')) {
        data = data.filter(resource => resource.type !== 5);
      }
      return data;
    });
  };
  var translateResource = resource => {
    return {
      ...resource,
      translatedName: $filter('translateList')(resource.id, 'resource', resource.name),
    };
  };
  var retrieveDetails = function(category) {
    if (category.loadingDetails) return;

    category.loadingDetails = true;
    return regResource.subresources(
      {
        id: category.id,
        showHistory: !!vm.showHistory,
      },
      function(data) {
        if (data) {
          category.resources = data.map(translateResource);
          category.showDetails = true;
        }

        category.loadingDetails = false;
      },
      function(error) {
        showError(error);
        category.loadingDetails = false;
      },
    ).$promise;
  };
  vm.toggleDetails = function(category) {
    if (category.isRemoved) return;
    if (category.type === 1 || category.type === 2 || category.type === 4 || category.type === 5)
      return; //Cost, travel, recup & training
    if (!category.showDetails && !category.resources) {
      retrieveDetails(category);
    } else {
      category.showDetails = !category.showDetails;
    }
  };
  vm.toggleResourceHistory = function() {
    vm.showHistory = !vm.showHistory;
    vm.resources.reload();
  };
  //#endregion

  //#region Category actions

  vm.addCategory = function() {
    regDialogsSvc.newCategory().then(function(data) {
      if (vm.resources && vm.resources.rows) vm.resources.rows.push(data);
      flySvc.success('msgNewItemSaved');
    });
  };

  vm.showDeleteCategoryDialog = function(category) {
    return regDialogsSvc.deleteResourceCategory(category).then(function(result) {
      if (!result) return;
      if (vm.showHistory && !result.isRemoved) {
        category.isRemoved = true;
        category.showDetails = false;
        return;
      }
      if (vm.resources && vm.resources.rows) {
        var idx = vm.resources.rows.findIndex(x => x.id === category.id);
        if (idx >= 0) vm.resources.rows.splice(idx, 1);
      }
    });
  };

  vm.deleteCategory = function(category) {
    if (category.deleting) return;
    category.deleting = true;
    if (
      !category.resources &&
      category.type !== 1 &&
      category.type !== 2 &&
      category.type !== 4 &&
      category.type !== 5
    ) {
      //Make sure sub resources are loaded
      retrieveDetails(category)
        .then(function() {
          return vm.showDeleteCategoryDialog(category);
        })
        .finally(() => {
          category.deleting = false;
        });
    } else {
      vm.showDeleteCategoryDialog(category).finally(() => {
        category.deleting = false;
      });
    }
  };
  vm.restoreCategory = function(category) {
    regResource.restoreCategory(
      {
        id: category.id,
      },
      function(data) {
        angular.extend(category, data, {
          loadingDetails: false,
          showDetails: false,
          resources: null,
        });
      },
      showError,
    );
  };

  vm.saveCategory = function(category, field, value) {
    if (!category || !field) return '';
    if (category[field] === value) return false;
    var model = angular.copy(category);
    model[field] = value;

    return regResource.updateCategory(model).$promise.then(function() {
      category[field] = value;
      flySvc.success('msgConfirmChange');
      return true;
    }, showError);
  };

  vm.updatePrice = function(category, value) {
    if (category.price === value) return false;
    return regResource
      .updatePrice({ id: category.id, price: value }, null)
      .$promise.then(function() {
        flySvc.success('msgConfirmChange');
        return true;
      }, showError);
  };
  vm.updateVatRate = function(category, vatRate, vatType) {
    if (category.vatPercentage === vatRate && category.vatType === vatType) return false;
    var model = angular.copy(category);
    model.vatPercentage = vatRate;
    model.vatType = vatType;

    return regResource.updateCategory(model).$promise.then(function(data) {
      angular.extend(category, data);
      flySvc.success('msgConfirmChange');
      return true;
    }, showError);
  };

  //#endregion

  //#region Resource actions
  vm.addResource = function(category) {
    regDialogsSvc.newSubResource(category).then(function(data) {
      flySvc.success('msgNewItemSaved');

      if (!category.resources) category.resources = [];
      category.resources.push(translateResource(data));
    });
  };

  vm.restoreResource = function(resource) {
    regResource.restoreResource(
      {
        id: resource.id,
      },
      function() {
        resource.isRemoved = false;
      },
      showError,
    );
  };

  vm.saveResource = function(resource, field, value) {
    if (!resource || !field) return '';
    if (resource[field] === value) return false;

    var model = angular.copy(resource);
    model[field] = value;

    if (field === 'inForfait') {
      return dialogsSvc
        .showYesNoCancel(
          'msgConfirmPropogateChangesTitle',
          'msgConfirmPropogateResourceForfaitChanges',
        )
        .then(
          function(result) {
            if (result === null) return false; // Cancel changes

            // This field is interpreted on the backend (but never used in the frontend)
            model.updateForfaitStatus = !!result;

            return regResource.updateResource(model).$promise.then(function() {
              resource[field] = value;
              flySvc.success('msgConfirmChange');
              return true;
            }, showError);
          },
          function() {
            // We get here on dialog box cancellation. We want to return true
            // otherwise the checkbox remains disabled
            return false;
          },
        );
    } else {
      return regResource.updateResource(model).$promise.then(function() {
        resource[field] = value;
        flySvc.success('msgConfirmChange');
        return true;
      }, showError);
    }
  };

  vm.updateCrmType = function(resource, data) {
    var model = { ...angular.copy(resource), ...(data || {}) };
    if (angular.equals(model, resource)) return false;
    return regResource.updateResource(model).$promise.then(function() {
      angular.extend(resource, data);
      flySvc.success('msgConfirmChange');
      return true;
    }, showError);
  };

  vm.deleteResource = function(category, resource) {
    return regDialogsSvc.deleteResource(category, resource).then(function(result) {
      if (!result) return;
      if (vm.showHistory && !result.isRemoved) {
        resource.isRemoved = true;
        return;
      }

      var idx = category.resources.findIndex(x => x.id === resource.id);
      if (idx >= 0) category.resources.splice(idx, 1);
    });
  };

  vm.updateInternalPrice = function(category, internalPrice) {
    if (category.internalPrice === internalPrice) return false;

    return dialogsSvc.updateInternalPrice(internalPrice).then(
      function(result) {
        if (!result) return false;
        result.categoryId = category.id;

        $http.put(appUrls.api + '/api/resource/updateInternalPrice', result).then(
          function(result) {
            flySvc.success();
            return true;
          },
          function(error) {
            flySvc.error(error.data.code, error.data.parameters);
            return '';
          },
        );
      },
      function(error) {
        return false;
      },
    );
  };

  vm.updateUseCounter = function(resource, data) {
    if (!resource) return false;
    if (resource.useCounter === data) return false;
    if (!!data) return vm.saveResource(resource, 'useCounter', data); //Turn on without confirmation

    return dialogsSvc.showYesNo('comfirmTitle', 'msgConfirmTurnOffAbsenceCounter').then(
      () => {
        return vm.saveResource(resource, 'useCounter', data);
      },
      () => false,
    );
  };
  vm.createReport = () => {
    vm.creatingReport = true;
    const filters = {
      ...vm.resources.currentParams(),
      culture: $translate.use(),
      connectionId: SignalRService.getConnectionId(),
      includeRemoved: !!vm.showHistory,
      type: -1, // show all resources
    };

    return $http.get(`${appUrls.api}/api/Resource/Report`, { params: filters }).then(
      function() {
        vm.creatingReport = false;

        flySvc.success('ExportToExcelStarted');
      },
      function(error) {
        vm.creatingReport = false;
        showError(error);
      },
    );
  };

  var deregistration = $rootScope.$on('$translateChangeSuccess', function() {
    // Redo subresource translations when the language changes
    // This code is also executed after translating a resource. The reload triggers this event.
    if (!vm.resources || !vm.resources.rows) return;
    vm.resources.rows.forEach(category => {
      if (category.resources && category.resources.length) {
        category.resources = category.resources.map(translateResource);
      }
    });
  });
  $scope.$on('$destroy', deregistration);
}
